<div class="main">
  <ion-card class="full-units-calculation" *ngIf="!lockEdits">
    <div class="drawer">
      <div class="text">
        <p>
          {{ 'i18n.menuProfitPro.unitOfMeasure.title' | translate }}
          <ion-icon
            name="information-circle"
            (click)="
              platform !== platformRef.desktop
                ? hoverInfoIcon($event)
                : undefined
            "
            (mouseover)="
              platform === platformRef.desktop
                ? hoverInfoIcon($event)
                : undefined
            "
          ></ion-icon>
        </p>
        <p>
          {{ 'i18n.menuProfitPro.unitOfMeasure.subTitle' | translate }}
        </p>
      </div>
      <ion-button
        *ngIf="platform !== platformRef.mobile"
        [ngClass]="
          !!baseQuantity &&
          !!conversionQuantity &&
          !!baseUnit &&
          !!conversionUnit
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-disabled-dsktp-tblt-modal-button'
        "
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="saveUnitsOfMeasureCalculation()"
      >
        {{ 'i18n.common.save' | translate }}</ion-button
      >
    </div>
    <div
      class="inputs"
      [class.mobile]="platform === platformRef.mobile"
      [class.tablet]="platform === platformRef.tablet"
    >
      <div class="conversion">
        <p class="instruction">
          {{
            'i18n.menuProfitPro.unitOfMeasure.instructionConversion' | translate
          }}
        </p>
        <div class="container">
          <div class="quantity">
            <P>{{ 'i18n.menuProfitPro.unitOfMeasure.quantity' | translate }}</P>
            <ion-input
              data-cy="ingredient-unit-conversion-quantity"
              customDecimal
              [maxLeftHandDigits]="4"
              [maxPrecision]="2"
              [value]="conversionQuantity"
              (ionChange)="updateConversionQuantity($event?.detail?.value)"
              [placeholder]="'#'"
            >
            </ion-input>
          </div>
          <div class="unit">
            <P>{{ 'i18n.menuProfitPro.unitOfMeasure.unit' | translate }}</P>
            <ion-item
              id="conversion-unit"
              data-cy="ingredient-unit-conversion-button"
              detail="true"
              detail-icon="chevron-down-outline"
              globalkeyhandler="input"
              (click)="clickConversionUnit($event)"
            >
              <ion-label
                data-cy="ingredient-unit-conversion-label"
                [class.gray-out]="!conversionUnit"
              >
                {{
                  (!!conversionUnit
                    ? conversionUnit
                    : 'i18n.menuProfitPro.ingredient.uOfM'
                  ) | translate
                }}
              </ion-label>
            </ion-item>
          </div>
        </div>
      </div>
      <div class="division" *ngIf="platform !== platformRef.mobile">
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </div>
      <div class="base">
        <p class="instruction">
          {{ 'i18n.menuProfitPro.unitOfMeasure.instructionBase' | translate }}
        </p>
        <div class="container">
          <div class="quantity">
            <P>{{ 'i18n.menuProfitPro.unitOfMeasure.quantity' | translate }}</P>
            <ion-input
              data-cy="ingredient-unit-base-quantity"
              customDecimal
              [maxLeftHandDigits]="4"
              [maxPrecision]="2"
              [value]="baseQuantity"
              (ionChange)="updateBaseQunatity($event?.detail?.value)"
              [placeholder]="'#'"
            ></ion-input>
          </div>
          <div class="unit">
            <P>{{ 'i18n.menuProfitPro.unitOfMeasure.unit' | translate }}</P>
            <ion-item
              id="base-unit"
              data-cy="ingredient-unit-base-button"
              detail="true"
              detail-icon="chevron-down-outline"
              globalkeyhandler="input"
              (click)="clickBaseUnit($event)"
            >
              <ion-label
                data-cy="ingredient-unit-base-label"
                [class.gray-out]="!baseUnit"
              >
                {{
                  (!!baseUnit ? baseUnit : 'i18n.menuProfitPro.ingredient.uOfM')
                    | translate
                }}
              </ion-label>
            </ion-item>
          </div>
        </div>
      </div>
    </div>
  </ion-card>

  <div class="conversion-results">
    <p>{{ 'i18n.menuProfitPro.unitOfMeasure.conversionTitle' | translate }}</p>
    <p>
      {{ 'i18n.menuProfitPro.unitOfMeasure.conversionSubTitle' | translate }}
    </p>
  </div>

  <div class="price-calculation">
    <div class="quantity">
      <P>{{ 'i18n.menuProfitPro.unitOfMeasure.quantity' | translate }}</P>
      <ion-label
        data-cy="ingredient-unit-solved-quantity"
        [class.gray-out]="!solvedQuantity"
        >{{ !!solvedQuantity ? (solvedQuantity | limitToTwoNum) : '#' }}
      </ion-label>
    </div>
    <div class="unit">
      <P>{{ 'i18n.menuProfitPro.unitOfMeasure.unit' | translate }}</P>
      <ion-item
        id="solved-unit"
        data-cy="ingredient-unit-solved-button"
        detail="true"
        detail-icon="chevron-down-outline"
        globalkeyhandler="input"
        (click)="clickResultUnit($event)"
      >
        <ion-label
          data-cy="ingredient-unit-solved-label"
          [class.gray-out]="!solvedUnit"
        >
          {{
            (!!solvedUnit ? solvedUnit : 'i18n.menuProfitPro.ingredient.uOfM')
              | translate
          }}
        </ion-label>
      </ion-item>
    </div>
    <div class="cost">
      <P>{{ 'i18n.menuProfitPro.unitOfMeasure.cpu' | translate }}</P>
      <P [class.gray-out]="!solvedCost">{{ solvedCost | currency }}</P>
    </div>
  </div>
</div>
